import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GetCourseTreeObject } from '../../stores/usercourseTreeobject.store';
import { EncriptDecriptService } from '../../services/encriptdecript';

@Injectable()
export class CourseNavigationService {

    constructor(public getCourseTreeObject: GetCourseTreeObject,
    private encriptDecript:EncriptDecriptService,
         private router: Router) { }

    public navigateToCourse(category) {
        localStorage.coursePageProberty = '';
        if (category.analytic == null || category.analytic === undefined) {
            this.encriptDecript.setToLocalStorage('coursePageProberty',JSON.stringify({
                queryParams: {
                    categoryId: category.categoryId,
                    categoryName: category.name,
                    bannerPath: category.bannerPath,
                    categoryDesc: category.description
                }
            }));
            this.router.navigate(['/user/course/browse'], {
                queryParams: {
                    categoryId: category.categoryId,
                    categoryName: category.name,
                    bannerPath: category.bannerPath,
                    categoryDesc: category.description
                }
            });
        } else if (category.fileType === 'video') {
            this.encriptDecript.setToLocalStorage('coursePageProberty',JSON.stringify({
                queryParams: {
                    categoryId: category.categoryId,
                    categoryName: category.name,
                    bannerPath: category.bannerPath,
                    categoryDesc: category.description,
                    categoryanalytic: category.analytic.lessonVideoProgress
                }
            }));
            this.router.navigate(['/user/course/browse'], {
                queryParams: {
                    categoryId: category.categoryId,
                    categoryName: category.name,
                    bannerPath: category.bannerPath,
                    categoryDesc: category.description,
                    categoryanalytic: category.analytic.lessonVideoProgress
                }
            });
        } else {
            this.encriptDecript.setToLocalStorage('coursePageProberty',JSON.stringify({
                queryParams: {
                    categoryId: category.categoryId,
                    categoryName: category.name,
                    bannerPath: category.bannerPath,
                    categoryDesc: category.description,
                    categoryanalytic: category.analytic.lessonCourseProgress
                }
            }));
            this.router.navigate(['/user/course/browse'], {
                queryParams: {
                    categoryId: category.categoryId,
                    categoryName: category.name,
                    bannerPath: category.bannerPath,
                    categoryDesc: category.description,
                    categoryanalytic: category.analytic.lessonCourseProgress
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/service/course-navigation.service.ts